// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fl","advertDetailContactItem__link":"c-n_fm"};